import { AiOutlineHome, AiOutlineGift } from "react-icons/ai";
import {
  RiShoppingBag3Line,
  RiUser3Line,
  RiFileListLine,
  RiPieChartLine,
  RiSettings3Line,
} from "react-icons/ri";
// import { MdCategory } from "react-icons/md";

import { FiMail } from "react-icons/fi";

/**
 * Sidebar Navigation Modules Configuration
 * Organized by functional groups for better UX
 */
export const SIDEBAR_MODULES = {
  main: {
    title: "Main",
    items: [
      {
        to: "/admin",
        icon: AiOutlineHome,
        label: "Dashboard",
        badge: null,
      },
      {
        to: "/admin/analytics",
        icon: RiPieChartLine,
        label: "Analytics",
        badge: null,
      },
      {
        to: "/admin/sales",
        icon: RiPieChartLine,
        label: "Sales",
        badge: null,
      },
    ],
  },
  ecommerce: {
    title: "E-Commerce",
    items: [
      {
        to: "/admin/orders",
        icon: RiFileListLine,
        label: "Orders",
        badge: "new",
      },
      {
        to: "/admin/products",
        icon: RiShoppingBag3Line,
        label: "Products",
        badge: null,
      },
    ],
  },
  content: {
    title: "Content",
    items: [
      {
        to: "/admin/knowledge-hub",
        icon: RiFileListLine, // Using FileList as fallback or I can import Video
        label: "Knowledge Hub",
        badge: null,
      },
      {
        to: "/admin/blogs",
        icon: RiFileListLine,
        label: "Blogs",
        badge: null,
      },
    ],
  },
  management: {
    title: "Management",
    items: [
      {
        to: "/admin/users",
        icon: RiUser3Line,
        label: "Customers",
        badge: null,
      },
      {
        to: "/admin/offers",
        icon: AiOutlineGift,
        label: "Offers",
        badge: null,
      },
      {
        to: "/admin/leads",
        icon: FiMail,
        label: "Leads",
        badge: "new",
      },
    ],
  },
  system: {
    title: "System",
    items: [
      {
        to: "/admin/settings",
        icon: RiSettings3Line,
        label: "Settings",
        badge: null,
      },
    ],
  },
};
